import React from "react";
import { View, StyleSheet, Text } from "react-native";

import IntegrationsHelper from "../IntegrationsHelper";
import INTEGRATIONS from "../home/data";
import fontStyles from "../../../fonts";
import ImageComponent from "../../common/ImageComponent";
import IntegrationsList from "../home/IntegrationsList";

const IntegrationMappingEmpty = (props) => {
  const { controller } = props;

  // Hide slack for non-admins
  const { show_admin_tools: isAdmin } = controller.state?.settings || {};
  let filteredIntegrations = isAdmin
    ? INTEGRATIONS
    : INTEGRATIONS.filter((int) => int.value != "slack");

  return (
    <View>
      <View style={styles.container}>
        <Text style={[fontStyles.h2, { textAlign: "center" }]}>
          Oh No! You haven’t connected any integrations!
        </Text>

        <ImageComponent
          image={require("../../../../assets/integrations/confusedMari.png")}
          style={styles.image}
        />

        <Text style={[fontStyles.h4, styles.bottomText]}>
          Tap one below to set is up so we can understand your time:
        </Text>
      </View>

      <IntegrationsList
        controller={controller}
        items={filteredIntegrations.slice(0, 6)}
        onItemSelected={IntegrationsHelper.toggleIntegration}
      />
    </View>
  );
};

export default IntegrationMappingEmpty;

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    marginTop: 16,
    marginBottom: 16,
  },
  bottomText: {
    textAlign: "center",
    maxWidth: 343,
    paddingLeft: 13,
    paddingRight: 19,
  },
  image: {
    width: 247,
    height: 234,
    marginTop: 16,
    marginBottom: 3,
  },
});
